

















// vendor
import { defineComponent } from "@vue/composition-api";
// project
import { RunScene } from "@/components.run/run-scene";
// local
import { getProps } from "../../ts/NodeComponent";

type SceneParams = {};

export default defineComponent({

	emits:[ "end", "previous" ],
	components:{
		RunScene
	},
	props:getProps<SceneParams>(),
	setup(props, context){

		const onEnd = () => context.emit("end");
		const onBack = () => context.emit("previous");

		return {
			onEnd,
			onBack
		};

	}
});

